var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImageCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17 18C20.3137 18 23 15.3137 23 12C23 8.68631 20.3137 6.00002 17 6.00002C13.6863 6.00002 11 8.68631 11 12C11 15.3137 13.6863 18 17 18Z",
    fill: "#002F6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.36 18.7C20.11 19.52 18.61 20 17 20C15.39 20 13.89 19.52 12.64 18.7C8.43997 20.08 5.10997 23.4 3.71997 27.6C6.82997 31.49 11.62 34 17 34C22.38 34 27.17 31.49 30.28 27.59C28.89 23.39 25.57 20.08 21.36 18.7Z",
    fill: "#002F6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageCircle);
export default __webpack_public_path__ + "static/media/NoImageCircle.8fc22b899245875d2c4564f2409d0035.svg";
export { ForwardRef as ReactComponent };